import { render, staticRenderFns } from "./PlgPaymentCard.vue?vue&type=template&id=ccdc02d4&scoped=true&"
import script from "./PlgPaymentCard.vue?vue&type=script&lang=js&"
export * from "./PlgPaymentCard.vue?vue&type=script&lang=js&"
import style0 from "./PlgPaymentCard.vue?vue&type=style&index=0&id=ccdc02d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdc02d4",
  null
  
)

export default component.exports